import { CustomProjectEntity, RawCustomProject } from './Types';
import { RawTemplate, TemplateEntity } from '../Template/Types';
import { TemplateModel } from '../Template/TemplateModel';
import { ItemTypeEntity, RawItemType } from '../ItemType/Types';
import { BaseProjectModel } from '../BaseProject/BaseProjectModel';
import {ItemTypeModel} from "../ItemType/ItemTypes";

export class CustomProjectModel extends BaseProjectModel implements CustomProjectEntity {
    storeId: number | null = null;
    progress: number = 0;
    lock: boolean = false;
    templatePaid?: boolean = false;
    templates?: TemplateEntity[];
    summaryItemTypesProject?: ItemTypeEntity[];

    constructor(project?: RawCustomProject) {
        super();
        if (project) {
            this.initialize(project);
        }
    }

    override initialize(project: RawCustomProject) {
        super.initialize(project);
        this.storeId = project.store_id ?? null;
        this.progress = project.progress ?? 0;
        this.templatePaid = project.template_paid ?? false;
        this.lock = project.lock ?? false;

        this.templates = project.data?.templates?.length
            ? project.data.templates.map(
                (template: RawTemplate) => new TemplateModel(template)
            )
            : [];

        this.summaryItemTypesProject = project.data?.summary_item_types_project?.length
            ? project.data.summary_item_types_project.map(
                (item: RawItemType) => new ItemTypeModel(item)
            )
            : [];
    }

    override parse(): RawCustomProject {
        return {
            ...super.parse(),
            store_id: this.storeId,
            progress: this.progress,
            template_paid: this.templatePaid,
            lock: this.lock,
            data: {
                templates: this.templates?.map(template => template.parse()) ?? [],
                summary_item_types_project: this.summaryItemTypesProject?.map(item =>
                    item.parse()
                ) ?? [],
            },
        };
    }
}
